import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Group, Modal, Stack, Text } from '@mantine/core';
import { useModalContainer } from '../../../contexts/ModalContainerContext';
import { writeLiveScheduleOffModalSkipPreference } from '../../../gantt/autoSchedulePreference';

export interface GanttLiveScheduleOffModalProps {
  opened: boolean;
  onClose: () => void;
}

export function GanttLiveScheduleOffModal({
  opened,
  onClose,
}: GanttLiveScheduleOffModalProps) {
  const modalContainer = useModalContainer();
  const [dontAskAgain, setDontAskAgain] = useState(false);

  useEffect(() => {
    if (opened) setDontAskAgain(false);
  }, [opened]);

  const dismiss = () => {
    if (dontAskAgain) {
      writeLiveScheduleOffModalSkipPreference(true);
    }
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={dismiss}
      title="Live Schedule is off"
      centered
      portalProps={modalContainer ? { target: modalContainer } : undefined}
    >
      <Stack gap="md">
        <Text size="sm">
          Dependent tasks will no longer update automatically when you change dates, duration, or
          dependencies.
        </Text>
        <Text size="sm">
          When you want the schedule recalculated, click{' '}
          <strong>Recalculate schedule</strong> in the toolbar.
        </Text>
        <Text size="xs" c="dimmed">
          Tip: turn Live Schedule back on if you want linked tasks to shift as you edit.
        </Text>
        <Group justify="space-between" align="center" gap="sm" mt="xs" wrap="nowrap">
          <Checkbox
            label="Don't ask again"
            checked={dontAskAgain}
            onChange={(e) => setDontAskAgain(e.currentTarget.checked)}
            styles={{
              label: { fontSize: 13, whiteSpace: 'nowrap' },
            }}
          />
          <Button variant="filled" color="brand" onClick={dismiss}>
            Got it
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
